import { render, staticRenderFns } from "./CamaraCaptura.vue?vue&type=template&id=3cf93e79&scoped=true"
import script from "./CamaraCaptura.vue?vue&type=script&lang=js"
export * from "./CamaraCaptura.vue?vue&type=script&lang=js"
import style0 from "./CamaraCaptura.vue?vue&type=style&index=0&id=3cf93e79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf93e79",
  null
  
)

export default component.exports